import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TransactionsReportChart from "../TransactionsReportChart/TransactionsReportChart";
import { TransactionsReportLoadingDialog } from "./transactions-report-loading-dialog/TransactionsReportLoadingDialog";
import * as actions from "./transactions-report-redux/transactionsReportActions";
import { TransactionsReportCard } from "./TransactionsReportCard";
import { TransactionsReportUIProvider } from "./TransactionsReportUIContext";
import {
  initialFilter,
  initialFilterChart
} from "./TransactionsReportUIHelpers";

export function TransactionsReportPage({ history }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [queryParamsChart, setQueryParamsChartBase] = useState(
    initialFilterChart
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.fetchTransactionsReportList(queryParams));
  }, [queryParams, dispatch]);

  useEffect(() => {
    dispatch(actions.fetchTransactionsChartDetails(queryParamsChart));
  }, [queryParamsChart, dispatch]);

  const transactionsReportUIEvents = {
    openReceiptDialog: (row) => {},
    handleExportButton: () => {
      dispatch(actions.exportTransactionsReportList(queryParams));
    }
  };

  return (
    <>
      <TransactionsReportUIProvider
        transactionsReportUIEvents={transactionsReportUIEvents}
        queryParams={queryParams}
        setQueryParamsBase={setQueryParamsBase}
        queryParamsChart={queryParamsChart}
        setQueryParamsChartBase={setQueryParamsChartBase}
      >
        <TransactionsReportLoadingDialog />

        <TransactionsReportChart />

        <TransactionsReportCard />
      </TransactionsReportUIProvider>
    </>
  );
}
